<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="router-view"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="router-view"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  provide(){
    return {
      root:this
    }
  },
  data(){
    return {
      device:this.$isMobile()
    }
  },
  components: {
  },
  mounted(){
    // alert(document.body.clientWidth+','+document.body.clientHeight)
  }
}
</script>

<style lang="scss" type="text/scss">
  body{
      margin: 0;
      padding:0;
  }
  .device_phone{
    &.ppd{
      margin-top: 10px !important;
    }
    &.notransform{
      div{
      font-size:13px !important;
      }      
      .titlebox .txt{
        font-size: 16px !important;
      }
    }  
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }
  .router-view{
    height: 100%;
    width: 100%;
  }
  .mcontent {
  color: #fff;
  height: 100%;
  display: flex;
  }


   
  .moblieline{
    height:250px;
    margin-top:10px;
    &.h150{
       height:150px;
    }
    &.h200{
       height:200px;
    }
    &.h300{
       height:300px;
    }
    &.hauto{
      height: auto;
    }
    &.h350{
       height:350px;
    }
      &.h400{
       height:400px;
    }
     &.h450{
       height:450px;
    }
     &.h550{
       height:550px;
    }
    &.h650{
       height:650px;
    }
     &.h750{
       height:750px;
    }
     &.h800{
       height:800px;
    }
    &.h850{
       height:850px;
    }
    &.h950{
       height:950px;
    }
        &.h1050{
       height:950px;
    }
    &:last-child{
      margin-bottom: 10px;
    }
  }
  //  .mipad{

  //   div{
  //    font-size: 14px !important; 
  //   }
  //  }
</style>
